import {
  ADD_SCHOOLS_APPLICATIONS,
  SCHOOLS_APPLICATIONS_API_REQUEST,
  SCHOOLS_APPLICATIONS_API_SUCCESS,
  SCHOOLS_APPLICATIONS_API_FAILURE,
} from '../actions/actionTypes';

const initialState = {
  loaded: false,
  loading: false,
  schools: [],
  normalSchools: {
    result: [],
  },
  parameters: [],
  error: null,
  optionsDict: {},
};

export default function schoolsApplications(state = initialState, action) {
  switch (action.type) {
    case ADD_SCHOOLS_APPLICATIONS: {
      // eslint-disable-next-line no-shadow
      const { schools, normal } = action.payload;
      return {
        ...state,
        loaded: true,
        loading: false,
        schools: [...state.schools, ...schools],
        normalSchools: normal,
      };
    }
    case SCHOOLS_APPLICATIONS_API_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SCHOOLS_APPLICATIONS_API_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case SCHOOLS_APPLICATIONS_API_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
}
